<template>
  <el-dialog
    :title="isEdit ? '编辑课程' : '新增课程'"
    width="60%"
    :visible="dialogVisible"
    @close="$emit('close')">
    <el-form label-position="top" v-if="isLoaded" :rules="rules" ref="ruleForm" :model="courseFrom" size="medium">
        <el-form-item label="课程名称：" prop="name">
          <el-input v-model="courseFrom.name"></el-input>
        </el-form-item>

        <el-form-item label="课程介绍：" prop="description">
          <el-input v-model="courseFrom.description"></el-input>
        </el-form-item>

        <el-form-item label="封面图片：" prop="coverUrl">
          <template slot="label">
            封面图片： <span class="image-upload-tip">(推荐尺寸为318×318像素)</span>
          </template>
          <div v-if="courseFrom.coverUrl" class="course-coverUrl-wrapper">
            <img class="course-list-page-image" :src="courseFrom.coverUrl | ossImageProcess">
            <el-button type="text" @click="courseFrom.coverUrl = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
          </div>
          <el-button v-else type="text" @click="handleListPageImageChange" icon="icon-add-cover"></el-button>
        </el-form-item>

        <el-form-item label="课程分组：" prop="courseGroupId">
          <el-col :span="15">
          <el-select v-model="courseFrom.courseGroupId" placeholder="选择课程分组" filterable>
            <el-option
              v-for="(item, index) in courseGroups"
              :key="index"
              :label="item.groupName"
              :value="item.id">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="课程状态：" prop="status">
          <el-col :span="15">
          <el-select v-model="courseFrom.status" placeholder="选择课程状态">
            <el-option
              v-for="(item, index) in courseStatus"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="课程类型：" prop="courseType">
          <el-col :span="15">
          <el-select v-model="courseFrom.courseType" placeholder="选择课程类型">
            <el-option
              v-for="(item, index) in courseTypes"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item v-if="courseFrom.courseType === 2" label="可参与用户：" prop="userTagId">
          <el-col :span="15">
          <el-select v-model="courseFrom.userTagId" placeholder="选择可参与学习用户标签" filterable>
              <el-option
                v-for="(item, index) in enrollScopeList"
                :key="index"
                :label="item.tagName"
                :value="item.id">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>
      </el-form>
    <span
      class="dialog-footer"
      slot="footer"
      >
      <el-button
        @click="$emit('close')"
        >取 消</el-button>

      <el-button
        type="primary"
        @click="handleSavaCourse"
        >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {fetchCourseGroupList, getEnrollScopeList, getCourseById, createCourse, editCourse} from '@/api/app/course';
import {statusTypeOptions, courseTypeOptions} from '@/const/crud/app/course';

export default {
  name: 'CourseDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    id: {
      type: Number,
      default: undefined,
    },
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoaded: false,
      courseFrom: {
        name: '',
        description:'',
        coverUrl: '',
        status: 2,
        courseType: 1,
        userTagId: undefined,
        examType: 1,
        examId: undefined,
        courseGroupId: undefined,
      },
      rules: {
        name: [
          { required: true, message: '课程名称不能为空', trigger: 'blur' },
        ],
        description: [
          { mix: 1, max: 512, message: '课程介绍在 1 到 512 个字符', trigger: 'blur' },
        ],
        coverUrl: [
          { required: true, message: "请选择活动列表页图片", trigger: 'blur' },
        ],
        userTagId: [
          { required: true, message: '可参与用户不能为空', trigger: 'blur' },
        ],
      },
      courseStatus: statusTypeOptions,
      courseTypes: courseTypeOptions,
      courseGroups: [],
      enrollScopeList: [],
    }
  },
  created() {
    if (this.isEdit && !isNaN(this.id)) {
      this.initDetail();
    } else {
      this.isLoaded = true;
    }
    this.getEnrollScopeList();
    this.getCourseGroup();
  },
  methods: {
    handleListPageImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.courseFrom.coverUrl = list[0].contentUrl;
        }
        this.$refs.ruleForm.validateField('coverUrl');
        }, 1);
    },
    getEnrollScopeList() {
      getEnrollScopeList().then(response =>{
        if (response.data.code === 0) {
          this.enrollScopeList = response.data.data;
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    getCourseGroup() {
      fetchCourseGroupList().then(response =>{
        if (response.data.code === 0) {
          this.courseGroups = response.data.data;
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    initDetail() {
      getCourseById(this.id).then(response => {
        if (response.data.code === 0) {
          let data = response.data.data;
          this.formatDetail(data);
        } else {
          this.$message({
            message: "无法编辑该课程",
            type: 'error',
          });
        }
        this.isLoaded = true;
      }).catch(error => {
        this.$message({
          message: error,
          type: 'error',
        });
        this.isLoaded = true;
      })
    },
    formatDetail(data) {
      Object.assign(this.courseFrom, data);
    },
    handleSavaCourse() {
      if (this.courseFrom.courseType === 2) {
        this.$refs.ruleForm.validateField('userTagId');
      }
      this.$refs.ruleForm.validate(async (valid, result) => {
        const params = Object.assign({}, this.courseFrom);
        if (this.isEdit) {
          params.id = this.id;
        }
        if (valid) {
          const func = this.isEdit ? editCourse : createCourse;
          func(params).then(response => {
            if (response.data.code === 0) {
              this.$message({
                message: this.isEdit ? '编辑成功' : '创建成功',
                type: 'success',
              });
              this.$emit('close');
              this.$emit('confirm-save');
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          this.$message({
            message: result[Object.keys(result)[0]][0].message || '请正确填写课程信息',
            type: 'warning'
          });
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.image-upload-tip {
  font-size: 12px;
  color: #7a869e;
}
.course-coverUrl-wrapper {
  position: relative;
  width: 708px;
  .course-coverUrl {
    width: 708px;
  }

  .course-list-page-image {
    width: 318px;
  }

  .icon-remove-image {
    position: absolute;
    right: -15px;
    top: 0;
  }
}
/deep/ .el-form-item {
  margin-bottom: 7px;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0px;
}
</style>
